import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, formatApiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading; false = anonymous; object = logged in
  const [usage, setUsage] = useState(null);

  const refreshUsage = useCallback(async () => {
    try {
      const { data } = await api.get("/me/usage");
      setUsage(data);
    } catch { /* ignore */ }
  }, []);

  const bootstrap = useCallback(async () => {
    const token = localStorage.getItem("ap_token");
    if (!token) { setUser(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      await refreshUsage();
    } catch {
      localStorage.removeItem("ap_token");
      setUser(false);
    }
  }, [refreshUsage]);

  useEffect(() => { bootstrap(); }, [bootstrap]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("ap_token", data.token);
    setUser(data.user);
    await refreshUsage();
    return data.user;
  };

  const register = async (name, email, password) => {
    const { data } = await api.post("/auth/register", { name, email, password });
    localStorage.setItem("ap_token", data.token);
    setUser(data.user);
    await refreshUsage();
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("ap_token");
    setUser(false);
    setUsage(null);
  };

  return (
    <AuthContext.Provider value={{ user, usage, login, register, logout, refreshUsage, formatApiError }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
